import { injectable } from 'inversify'

import { ConvertGeometryStage, PreparedUserGeometryData } from '../protocols/UserGeometry'
import { BaseState } from './BaseState'

export interface UserGeometryUploadStateProps {
  file: File | null
  // Conversion progress in the 0..1 range, as reported by the pipeline.
  progress: number
  stage: ConvertGeometryStage | null
  error: string | null
  // Poll-based cancel handle: the conversion control reads this via isCancelled().
  cancelRequested: boolean
  preparedData: PreparedUserGeometryData | null
}

const INITIAL_STATE: UserGeometryUploadStateProps = {
  file: null,
  progress: 0,
  stage: null,
  error: null,
  cancelRequested: false,
  preparedData: null
}

@injectable()
export class UserGeometryUploadState extends BaseState<UserGeometryUploadStateProps> {
  constructor() {
    super(INITIAL_STATE)
  }

  setFile(file: File | null) {
    this._updateStateProp('file', file)
  }

  setProgress(progress: number) {
    this._updateStateProp('progress', progress)
  }

  setStage(stage: ConvertGeometryStage | null) {
    this._updateStateProp('stage', stage)
  }

  setError(error: string | null) {
    this._updateStateProp('error', error)
  }

  setCancelRequested(cancelRequested: boolean) {
    this._updateStateProp('cancelRequested', cancelRequested)
  }

  setPreparedData(preparedData: PreparedUserGeometryData | null) {
    this._updateStateProp('preparedData', preparedData)
  }

  reset() {
    this.resetState()
  }
}
